import { __extends } from "tslib";
import { ShaderDefineExpression } from "../shaderDefineExpression.js";
/** @hidden */
var ShaderDefineAndOperator = /** @class */ (function (_super) {
    __extends(ShaderDefineAndOperator, _super);
    function ShaderDefineAndOperator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShaderDefineAndOperator.prototype.isTrue = function (preprocessors) {
        return this.leftOperand.isTrue(preprocessors) && this.rightOperand.isTrue(preprocessors);
    };
    return ShaderDefineAndOperator;
}(ShaderDefineExpression));
export { ShaderDefineAndOperator };
//# sourceMappingURL=shaderDefineAndOperator.js.map